import type { ReactNode } from 'react'
import DocLayout from '../components/docs/DocLayout'
import Cased from '@/components/ui/Cased'
export default function PolicyPage({
  title,
  intro,
  children,
}: {
  title: string
  intro: string
  children: ReactNode
}) {
  return (
    <DocLayout section={{ label: 'About', to: '/about' }} eyebrow="About MDS" title={title} intro={intro}>
      {children}
    </DocLayout>
  )
}
export function Section({
  id,
  heading,
  children,
}: {
  id: string
  heading: string
  children: ReactNode
}) {
  return (
    <section className="doc-section" aria-labelledby={id}>
      <h2 id={id}><Cased>{heading}</Cased></h2>
      <div className="mds-prose">{children}</div>
    </section>
  )
}
